<template>
    <span
        v-bind="forwarded"
        :style="extraStyle"
        class="material-symbol-slot inline-flex items-center justify-center align-middle"
        aria-hidden="true"
        v-html="markup"
    />
</template>

<script setup>
import { computed, ref, useAttrs, watch } from 'vue';

import { getMaterialSymbolSvg } from '../utils/lazyMaterialSymbolSvgs.js';

defineOptions({ inheritAttrs: false });

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
});

const attrs = useAttrs();

const slug = computed(() => {
    const raw = String(props.name ?? '')
        .trim()
        .replace(/[^a-zA-Z0-9_]/g, '')
        .toLowerCase();
    const key = raw.replace(/_/g, '-');

    return key !== '' ? key : 'help';
});

const markup = ref('');

watch(
    slug,
    async (nextSlug) => {
        markup.value = await getMaterialSymbolSvg(nextSlug);
    },
    { immediate: true }
);

const extraStyle = computed(() => attrs.style);

const forwarded = computed(() => {
    const { style: _style, ...rest } = attrs;
    void _style;

    return rest;
});
</script>
